import './exhibitors-catalog.css';
import {
  NoResults,
  SearchBox,
  Stats,
  SortBy,
  RefinementListPanel,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import InfiniteHits from '@white-nl/instantsearch-components/dist/components/results/InfiniteHits';
import { Hit, Loading } from '../../components/exhibitors/results';

const settings = document.getElementById('catalog-exhibitors')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  window.initMobileNavFilters();
  window.initPinning('#filters-wrap--exhibitors');

  const apiUrl = window.Craft.getSiteUrl('api/react/exhibitors');

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
      } = data;

      const {
        exhibitors,
      } = translates;

      const currentRefinementsExclude = [];
      if (settings.fair) {
        currentRefinementsExclude.push('fair');
      }
      if (settings.type) {
        currentRefinementsExclude.push('type');
      }

      whiteInstantSearchCatalog
        .withSearchkit(
          settings.indexName,
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addTrailingSlashesToUrls: window.Craft.trailingSlashes,
          writeDelay: 0,
        })
        .addAdditionalData({
          exhibitors,
          fair: settings.fair,
        })
        .addSearchingComponent(
          [
            {
              settings: {
                placeholder: window.Craft.t(exhibitors, 'Search for exhibitors', {}),
              },
              component: SearchBox,
            },
          ],
          '.white-instant-search-search-box',
        );
      if (settings.type) {
        whiteInstantSearchCatalog.whereQuery(`type="${settings.type}"`);
      } else {
        whiteInstantSearchCatalog.addRefinementList(
          [{
            settings: {
              attribute: 'type',
              sortBy: ['name:asc'],
              limit: 999,
              searchable: false,
              showMore: false,
              panelSettings: {
                collapsiblePanelSettings: {
                  defaultExpanded: true,
                  canCollapse: true,
                },
                header: window.Craft.t(exhibitors, 'Exhibitor Type', {}),
                hideIfEmpty: true,
              },
            },
            component: RefinementListPanel,
          },
          ],
        );
      }
      if (settings.fair) {
        whiteInstantSearchCatalog.whereQuery(`fair="${settings.fair}"`);
      } else {
        whiteInstantSearchCatalog.addRefinementList(
          [{
            settings: {
              attribute: 'fair',
              sortBy: ['name:asc'],
              limit: 999,
              searchable: false,
              showMore: false,
              panelSettings: {
                collapsiblePanelSettings: {
                  defaultExpanded: true,
                  canCollapse: true,
                },
                header: window.Craft.t(exhibitors, 'Fairs', {}),
                hideIfEmpty: true,
              },
            },
            component: RefinementListPanel,
          },
          ],
        );
      }
      whiteInstantSearchCatalog.addRefinementList(
        [{
          settings: {
            attribute: 'location',
            sortBy: ['name:asc'],
            limit: 999,
            searchable: false,
            showMore: false,
            panelSettings: {
              collapsiblePanelSettings: {
                defaultExpanded: true,
                canCollapse: true,
              },
              header: window.Craft.t(exhibitors, 'Locations', {}),
              hideIfEmpty: true,
            },
          },
          component: RefinementListPanel,
        },
        ],
      )
        .addRefinementList(
          [{
            settings: {
              attribute: 'fairSection',
              sortBy: ['name:asc'],
              limit: 999,
              searchable: false,
              showMore: false,
              panelSettings: {
                collapsiblePanelSettings: {
                  defaultExpanded: true,
                  canCollapse: true,
                },
                header: window.Craft.t(exhibitors, 'Fair Sections', {}),
                hideIfEmpty: true,
              },
            },
            component: RefinementListPanel,
          },
          ],
        )
        .addSortByComponent(
          [
            {
              settings: {
                items: [
                  {
                    label: window.Craft.t(exhibitors, 'Best Match', {}),
                    value: settings.indexName,
                  },
                  {
                    label: window.Craft.t(exhibitors, 'A-Z', {}),
                    value: `${settings.indexName}exhibitors_by_title_asc`,
                  },
                  {
                    label: window.Craft.t(exhibitors, 'Z-A', {}),
                    value: `${settings.indexName}exhibitors_by_title_desc`,
                  },
                ],
              },
              component: SortBy,
            },
          ],
        )
        .addStatsComponent(
          [
            {
              settings: {
                translations: {
                  resultsFound: '',
                  resultFound: '',
                },
              },
              component: Stats,
            },
          ],
          '.hits-count',
        )
        .addCurrentRefinementsComponent(
          [
            {
              settings: {
                excludedAttributes: currentRefinementsExclude,
              },
              component: ({ currentRefinements }) => {
                const { items } = currentRefinements;
                return items.length > 0 ? items.length : '';
              },
            },
          ],
          '.counter-filters',
        )
        .addHitComponent(
          [
            {
              settings: {
                noResults: {
                  translations: {
                    noResults: window.Craft.t(exhibitors, 'Sorry, we can\'t find any content!', {}),
                    refinements: window.Craft.t(exhibitors, 'Try to choose another category or filter.', {}),
                    query: window.Craft.t(exhibitors, 'Please try another query.', {}),
                  },
                },
                infiniteHits: {
                  autoLoad: true,
                  classNames: {
                    root: 'col-12',
                    list: 'row gy-3',
                  },
                  translations: {
                    showMoreButtonText: window.Craft.t(exhibitors, 'Loading...', {}),
                  },
                },
              },
              component: Hit,
              loadingComponent: Loading,
              noResultsComponent: NoResults,
              infiniteScrolling: true,
              infiniteHitsComponent: InfiniteHits,
            },
          ],
          '#white-instant-search-hits',
        )
        .setHitsPerPage(12);

      whiteInstantSearchCatalog
        .build()
        .show();
    });
}
